import { FC, ReactNode, useCallback, useMemo } from 'react'
import * as moment from 'moment'
import { Subscription } from 'interfaces/subscription'
import { formatUSCurrency } from 'helpers/formatHelpers'
import TextButton from 'components/atoms/buttons/TextButton'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { modifyFloatingPaneActionCreator } from 'actions/floatingPanesActions'

import styles from 'components/features/pfm/SubscriptionAmountSection/SubscriptionAmountSection.styl'

type SubscriptionAmountSectionProps = Subscription

export const SubscriptionAmountSection: FC<SubscriptionAmountSectionProps> = (props) => {
  const { amount, next_billing_date, cancel_date } = props
  const numAmount = Number(amount)

  const dispatch = useStoreDispatch()
  const handleClick = useCallback(() => {
    dispatch(modifyFloatingPaneActionCreator(
      'subscription',
      { mode: 'edit-payment', amount: numAmount }
    ))
  }, [dispatch, numAmount])

  const cancelDateNode = useMemo((): ReactNode => (
    Boolean(cancel_date) && (
      <div className={ styles.subscriptionAmountSection }>
        <div className={ styles.label }>Your Premium membership is active until <span className={ styles.bold }>{ moment(cancel_date as string).format('MMMM Do YYYY') }</span></div>
      </div>
    )
  ), [cancel_date])
  const nextPaymentNode = useMemo((): ReactNode => (
    Boolean(numAmount && next_billing_date) && (
      <div className={ styles.subscriptionAmountSection }>
        <div className={ styles.label }>Next Payment</div>
        <div className={ styles.amountLine }>
          <div className={ styles.amount }>{ formatUSCurrency(numAmount) }</div>
          <div className={ styles.date }>{ moment(next_billing_date as string).format('[on] MMMM Do YYYY') }</div>
          <div className={ styles.cta }>
            <TextButton size='large' onClick={ handleClick }>Edit</TextButton>
          </div>
        </div>
      </div>
    )
  ), [next_billing_date, numAmount, handleClick])

  return (
    <>
      { nextPaymentNode }
      { cancelDateNode }
    </>
  )
}
